export class Department {
  constructor(public id: number | null, public name: string) {}

  public static get EMPTY(): Department {
    return new Department(null, "");
  }

  hasValidName(): boolean {
    return !!this.name && this.name.trim().length > 0;
  }
}
